import { DashboardService } from "../../../dashboard.service";
import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../accountant/accountant.service";
import { MyAccountService } from "../modals/my-account-modal.service";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { ImageCroppedEvent, ImageCropperModule } from "ngx-image-cropper";
import { SmsVerificationModalComponent } from "./sms-verification-modal.component";
import { NgIf } from "@angular/common";
import { SharedDataService } from "src/app/dashboard/shared-data.service";
declare var jQuery: any;

/* This is a component which we pass in modal*/
@Component({
    selector: "my-account-modal",
    templateUrl: "./my-account-modal.component.html",
    imports: [NgIf, ImageCropperModule, FormsModule, ReactiveFormsModule]
})
export class MyAccountModalComponent implements OnInit {
  has_pin = false;
  pinEdit = false;
  updatingPassword = false;
  accountForm: UntypedFormGroup;
  passwordForm: UntypedFormGroup;
  pinForm: UntypedFormGroup;
  formUtil: FormUtil = new FormUtil();
  fileForm: FormData = new FormData();
  user: any = {};
  data: any = {};
  showLoading = false;
  verificationCode: string;
  imageChangedEvent: any = null;
  croppedImage: any = "";
  phone_info = {
    phone_number: "",
    is_phone_number_verified: false,
    is_2fa_enabled: false,
  };

  public modalRef: BsModalRef;

  @ViewChild("avatarInput") avatarInput: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private dashboardService: DashboardService,
    private myAccountService: MyAccountService,
    private formBuilder: UntypedFormBuilder,
    private localStorage: LocalStorageService,
    private modalService: BsModalService,
    private toastr: HotToastService,
    private _elRef: ElementRef,
    private sharedDataService: SharedDataService,
    vcr: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.user = this.sharedDataService.user;
    this.data = this.sharedDataService.data;
    this.has_pin = this.data["has_pin"];

    console.log(this.has_pin);

    this.accountForm = this.formBuilder.group({
      timezone: [null, [Validators.required]],
    });

    this.passwordForm = this.formBuilder.group({
      currentPassword: [null, [Validators.required]],
      newPassword: [null, [Validators.required]],
      confirmPassword: [null, [Validators.required]],
    });

    this.pinForm = this.formBuilder.group({
      currentPin: [null, []],
      newPin: [
        null,
        [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      ],
      confirmPin: [
        null,
        [Validators.required, Validators.minLength(4), Validators.maxLength(4)],
      ],
      pinTimeout: [null, [Validators.required]],
    });

    this.myAccountService.get_2fa_status().then((res) => {
      this.phone_info = res;
    });
  }

  changePassword(): void {
    console.log(
      this.passwordForm.valid,
      this.passwordForm.get("newPassword").value,
      this.passwordForm.get("confirmPassword").value,
    );

    this.dashboardService.show_loading.next(true);

    this.myAccountService
      .change_user_data({
        currentPassword: this.passwordForm.get("currentPassword").value,
        newPassword: this.passwordForm.get("newPassword").value,
        isUpdatingPassword: this.updatingPassword,
        phone_number: this.data.phone_number,
      })
      .then(
        (res) => {
          const response = res;
          this.dashboardService.show_loading.next(false);
          this.toastr.success(response.message);
          this.updatingPassword = false;
          this.passwordForm.reset();
        },
        (err) => {
          this.dashboardService.show_loading.next(false);
          this.toastr.success(err.error.message);
        },
      );
  }

  verifySmsCode() {
    this.dashboardService.show_loading.next(true);
    this.myAccountService.verify_sms_token(this.verificationCode).then(
      (res) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.success(res.message);
        this.verificationCode = "";
        this.data.is_phone_number_verified = res.is_phone_number_verified;
      },
      (err) => {
        this.dashboardService.show_loading.next(false);
        this.toastr.error(err.error.message);
      },
    );
  }

  savePin(): void {
    console.log(
      this.pinForm.valid,
      this.pinForm.get("newPin").value,
      this.pinForm.get("confirmPin").value,
    );

    if (!this.has_pin || this.has_pin === undefined) {
      if (
        this.pinForm.valid &&
        this.pinForm.get("newPin").value ===
          this.pinForm.get("confirmPin").value
      ) {
        this.dashboardService.show_loading.next(true);

        this.myAccountService
          .add_pin(
            this.pinForm.get("newPin").value,
            this.pinForm.get("pinTimeout").value,
          )
          .then(
            (res) => {
              const response = res;
              this.data.has_pin = response.has_pin;
              this.has_pin = response.has_pin;
              this.localStorage.set("data", this.data);
              this.localStorage.remove("pin_expires");
              this.dashboardService.show_loading.next(false);
              this.toastr.success(response.message);
              this.pinEdit = false;
              this.pinForm.reset();
            },
            (err) => {
              this.dashboardService.show_loading.next(false);
              this.toastr.error(err.error.message);
            },
          );
      }
    } else {
      if (
        this.pinForm.valid &&
        this.pinForm.get("newPin").value ===
          this.pinForm.get("confirmPin").value
      ) {
        this.dashboardService.show_loading.next(true);

        this.myAccountService
          .change_pin(
            this.pinForm.get("currentPin").value,
            this.pinForm.get("newPin").value,
            this.pinForm.get("pinTimeout").value,
          )
          .then(
            (res) => {
              const response = res;
              this.dashboardService.show_loading.next(false);
              this.toastr.success(response.message);
              this.updatingPassword = false;
              this.pinEdit = false;
              this.localStorage.remove("pin_expires");
              this.pinForm.reset();
            },
            (err) => {
              this.dashboardService.show_loading.next(false);
              this.toastr.error(err.error.message);
            },
          );
      }
    }
  }

  fileChangeEvent(event: any): void {
    console.log(event);
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    console.log(event);
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  savePicture() {
    this.showLoading = true;
    this.imageChangedEvent = null;

    let formData = new FormData();
    this.fileForm.append("picture", this.croppedImage);

    this.myAccountService.savePicture(this.croppedImage).subscribe((res) => {
      this.data.pictureUrl = res.pictureUrl;
      this.user.pictureUrl = res.pictureUrl;
      this.localStorage.set("data", this.data);
      this.localStorage.set("user", this.user);
      setTimeout(() => {
        this.showLoading = false;
        this.toastr.success("Avatar updated.");
      }, 1000);
    });
  }

  openSmsVerificationModal() {
    this.bsModalRef.hide();

    setTimeout(() => {
      this.modalRef = this.modalService.show(SmsVerificationModalComponent, {
        class: "modal-md",
        initialState: { fromLogin: false },
      });

      this.modalRef.content.onClose.subscribe((result) => {
        console.log("results", result);
      });
    }, 300);
  }
}
